import { Col, Container, Row } from "reactstrap";

const Benefit = () => {

  const listBenefits = [
    { title:"Lingkungan Belajar Global", body:"Kamu akan belajar bareng teman dari banyak negara, yang bikin pengalamanmu makin internasional." },
    { title:"Peluang Kerja Sambil Kuliah", body:"Dengan visa pelajar, kamu bisa kerja paruh waktu sambil kuliah di Irlandia (syarat tergantung aturan visa)." },
    { title:"Karier Support", body:"Griffith punya layanan karier yang bantu kamu siap interview & connect ke employer." },
    { title:"Hidup & Belajar di Eropa", body:"Irlandia itu aman, seru, dan strategis buat explore Eropa saat liburan!." },
  ]

  return (
    <section className="section benefit-wrapper" id="benefit">
      <Container>
        <Row>
          <Col xs='12' md='7' className="benefit-items">
            <h1><b>Benefit Kuliah di Griffith College Ireland</b></h1>
              <ol>
                {listBenefits.map((item, id) => (
                  <li key={id}>
                    {item.title}
                    <p className="fw-normal">{item.body}</p>
                  </li>
                ))}
              </ol>
          </Col>    
          <Col xs='12' md='5' className='benefit-bg'>
            <img 
              src="assets/images/benefit-bg.webp" 
              alt="student-searching-benefits-study-at-melbourne-poly" 
              className="img-fluid"
            />
          </Col>        
        </Row>
      </Container>
    </section>
  );
};

export default Benefit;